(function () {
  const mobileTop = document.querySelector('[data-ccm-mobile-menu]');
  if (!mobileTop) return;

  const moreBtn = document.getElementById('moreBtn');
  const morePanel = document.getElementById('morePanel');
  const themeToggle = document.getElementById('themeToggle');
  const modeButtons = Array.from(document.querySelectorAll('[data-ccm-theme-mode]'));
  const THEME_STORAGE_KEY = 'ccm-theme-mode';

  function getStoredTheme() {
    try {
      const value = window.localStorage.getItem(THEME_STORAGE_KEY);
      return value === 'dark' || value === 'light' ? value : null;
    } catch (_) {
      return null;
    }
  }

  function storeTheme(mode) {
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, mode);
    } catch (_) {}
  }

  function setLightPreview(isLight, persist) {
    const mode = isLight ? 'light' : 'dark';
    if (persist) storeTheme(mode);
    document.documentElement.setAttribute('data-ccm-theme', mode);
    document.body.classList.toggle('ccm-light-preview', isLight);
    document.body.classList.toggle('theme-light', isLight);
    document.body.classList.toggle('theme-dark', !isLight);

    const home = document.querySelector('.ccm-home-page');
    if (home) {
      home.classList.toggle('theme-light', isLight);
      home.classList.toggle('theme-dark', !isLight);
      home.setAttribute('data-ccm-mode', isLight ? 'light' : 'dark');
    }

    document.querySelectorAll('[data-ccm-product-v5]').forEach((root) => {
      root.classList.toggle('theme-light', isLight);
      root.classList.toggle('theme-dark', !isLight);
      root.setAttribute('data-ccm-mode', isLight ? 'light' : 'dark');
    });

    modeButtons.forEach((button) => {
      button.classList.toggle('active', button.dataset.ccmThemeMode === (isLight ? 'light' : 'dark'));
    });

    if (themeToggle) {
      themeToggle.setAttribute('aria-pressed', String(isLight));
    }

    document.querySelectorAll('.modeBtn').forEach((button) => {
      const mode = button.dataset.theme || button.dataset.mode;
      button.classList.toggle('active', mode === (isLight ? 'light' : 'dark'));
    });
  }

  const storedTheme = getStoredTheme();
  setLightPreview(storedTheme ? storedTheme === 'light' : (document.body.classList.contains('ccm-light-preview') || document.body.classList.contains('theme-light')));

  if (moreBtn && morePanel) {
    moreBtn.addEventListener('click', () => {
      const isOpen = morePanel.classList.toggle('is-open');
      moreBtn.setAttribute('aria-expanded', String(isOpen));
    });
  }

  if (themeToggle) {
    themeToggle.addEventListener('click', () => {
      setLightPreview(!document.body.classList.contains('ccm-light-preview'), true);
    });
  }

  modeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      setLightPreview(button.dataset.ccmThemeMode === 'light', true);
    });
  });

  document.addEventListener('click', (event) => {
    if (morePanel && moreBtn && morePanel.classList.contains('is-open') && !mobileTop.contains(event.target)) {
      morePanel.classList.remove('is-open');
      moreBtn.setAttribute('aria-expanded', 'false');
    }
  });

  let lastScrollY = window.scrollY;
  let ticking = false;
  const threshold = 8;
  let lastToggleAt = 0;
  const toggleDelay = 160;

  function updateMobileHeader() {
    const currentY = window.scrollY;
    const delta = currentY - lastScrollY;

    if (window.innerWidth <= 760) {
      const now = Date.now();
      const canToggle = now - lastToggleAt > toggleDelay;

      if (canToggle && currentY > 34 && delta > threshold) {
        document.body.classList.add('ccm-hide-nav');
        if (morePanel) morePanel.classList.remove('is-open');
        if (moreBtn) moreBtn.setAttribute('aria-expanded', 'false');
        lastToggleAt = now;
      } else if (canToggle && (delta < -threshold || currentY < 20)) {
        document.body.classList.remove('ccm-hide-nav');
        lastToggleAt = now;
      }
    } else {
      document.body.classList.remove('ccm-hide-nav');
    }

    lastScrollY = currentY;
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateMobileHeader);
      ticking = true;
    }
  }, { passive: true });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 760) document.body.classList.remove('ccm-hide-nav');
  });
})();
